module.exports = __webpack_public_path__ + "static/img/img-placeholder.fb1a6f0b.svg";